import React, { useEffect, useState } from 'react';

const DISMISS_KEY = 'announcement-banner-dismissed';

const AnnouncementBanner = () => {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(localStorage.getItem(DISMISS_KEY) === 'true');
  }, []);

  if (dismissed) return null;

  return (
    <div className="relative flex flex-wrap items-center justify-center gap-x-2 w-full pl-10 pr-10 md:pl-0 text-base text-center py-4 bg-very-dark-grey text-bright-white border-b border-soft-blue-grey">
      <span>Looking for the latest version of the docs?</span>
      <a
        href="https://docs.domino.ai"
        target="_blank"
        rel="noreferrer"
        className="rounded-full bg-vivid-orange text-very-dark-grey px-4 py-1 font-semibold hover:bg-bright-white transition-colors"
      >
        Go to docs.domino.ai
      </a>
      <button
        onClick={() => {
          localStorage.setItem(DISMISS_KEY, 'true');
          setDismissed(true);
        }}
        aria-label="Dismiss"
        className="absolute left-2 md:left-auto md:right-2 shrink-0 cursor-pointer w-7 h-7 rounded-full flex items-center justify-center text-lg leading-none hover:bg-black/10 text-bright-white hover:text-vivid-orange"
      >
        &times;
      </button>
    </div>
  );
};

export default AnnouncementBanner;
